import { TextField as MaterialTextField } from "@material-ui/core";
import styled from "styled-components";

import React, { ReactNode } from "react";

export type TextFieldProps = React.ComponentProps<
  typeof MaterialTextField
> & {};

export const TextField = styled(MaterialTextField).attrs({
  variant: "outlined",
})<{
  label?: ReactNode;
}>`
  ${({ label }) => (label === undefined ? "margin-top: 0" : "")}
`;
